import React from "react";
import WelcomeIntro from "./WelcomeIntro";
import WelcomeTerms from "./WelcomeTerms";
import { withNamespaces } from "react-i18next";
import { Modal } from "reactstrap";
const INTRO = "intro";
const TERMS = "terms";

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.state = {
      content: INTRO
    };
  }

  next() {
    if (this.state.content === TERMS) {
      this.props.toggle();
    } else {
      this.setState({ content: TERMS });
    }
  }

  render() {
    let content = null;
    if (this.state.content === INTRO) {
      content = <WelcomeIntro next={this.next} />;
    } else {
      content = <WelcomeTerms next={this.next} />;
    }

    return (
      <Modal isOpen={this.props.open} toggle={this.props.next}>
        {content}
      </Modal>
    );
  }
}

export default withNamespaces()(Welcome);



// WEBPACK FOOTER //
// ./src/Welcome.jsx